module.exports = __webpack_public_path__ + "img/feature-01-zh.3a3e6a69.png";